module.exports = __webpack_public_path__ + "img/calendarbg.fd926823.svg";